<template>
  <v-card flat class="w-100">
    <template v-if="item.channel_id === 6 || item.channel_id === 4 || item.channel_id === 3 || item.channel_id === 5">
      <av-line
        v-if="item.url_record"
        :line-width="1"
        :canv-width="600"
        :canv-heigh="80"
        line-color="#ff7c64"
        :canv-top="true"
        :cors-anonym="true"
        class="customized-audio"
        :audio-src="`${item.url_record}`"
      ></av-line>
      <span v-else class="d-block text-xs-center">
        No posee audio.
      </span>
    </template>
    <!-- <template v-if="more === false || more === 0">
      <v-card-text class="px-0 py-1" v-if="i === 0 && item.processed_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Gestión procesada
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.processed_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="i === 0 && item.sent_carrier_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Enviado al operador
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.sent_carrier_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="i === 0 && item.sent_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Enviado al cliente
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.set_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="i === 0 && item.delivered_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Entregado al cliente
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.delivered_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="i === 0 && item.read_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Leido
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.read_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="i === 0 && item.click_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Click a {{notificationDetail.url}}
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.click_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="i === 0 && item.payment_promise">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Se comprometió
              </v-flex>
              <v-flex md12>
                <small>{{ formatDate(item.payment_promise, 'YYYY-MM-DD', 'DD/MM/YYYY') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </template> -->
    <template>
      <v-card-text class="px-0 py-1" v-if="item.processed_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Gestión procesada
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.processed_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="item.sent_carrier_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Enviado al operador
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.sent_carrier_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="item.sent_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Enviado al cliente
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.sent_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="item.delivered_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Entregado al cliente
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.delivered_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="item.read_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Leido
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.read_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="item.click_at">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Click a {{notificationDetail.url}}
              </v-flex>
              <v-flex md12>
                <small>{{ utcToLocal(item.click_at, 'DD/MM/YYYY h:mm A') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="px-0 py-1" v-if="item.payment_promise">
        <v-layout row wrap>
          <v-flex md2 class="text-xs-center">
            <v-avatar
              size="40"
              class="transparent"
              >
              <v-icon class="k-orange-linear-text">fas fa-clipboard-list</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex md8>
            <v-layout row wrap>
              <v-flex md12>
                Se comprometió
              </v-flex>
              <v-flex md12>
                <small>{{ formatDate(item.payment_promise, 'YYYY-MM-DD', 'DD/MM/YYYY') }}</small>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </template>
  </v-card>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    i: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      more: false,
    };
  },
  methods: {
    utcToLocal(date, format) {
      return moment.utc(date).local().format(format);
    },
    formatDate(date, formatDate, format) {
      return moment(date, formatDate).format(format);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/customer/NotificationInfo.vue